export const queryKeys = {
  user: {
    get: "user",
  },

  purchase: {
    checkoutSummary: "checkout-summary",
    purchasePackages: "purchase-packages",
    applyPromoCode: "apply-promo",
    orderHistory: "order-history",
    orderByTid: "order-by-tid",
    walletRefresh: "wallet-refresh",
    topupCountries: "topup-countries",
    topupContinents: "topup-continents",
    topupPackages: "topup-packages",
    availableEsimsForTopup: "available-esims-for-topup",
  },

  sims: {
    myEsims: "my-esims",
    pendingEsims: "pending-esims",
    esimDetail: "esim-detail",
    redeem: "redeem",
    renew: "renew",
    dataOnlySims: "data-only-sims",
    dataVoiceSims: "data-voice-sims",
    addSimLabel: "add-sim-label",
  },

  blogs: {
    getBlogs: "get-blogs",
    categories: "blog-categories",
    detail: "blog-detail",
    slugs: "blog-slugs",
  },

  misc: {
    compatibleDevices: "compatile-devices",
  },

  packages: {
    searchPackagesList: "search-packages-list",
    topDestinations: "topDestinations",
    countriesThatHavePackages: "countries-that-have-packages",
    countriesThatHaveDataVoicePackages:
      "countries-that-have-data-voice-packages",
    regionsThatHavePackages: "regions-that-have-packages",
    regionsThatHaveDataVoicePackages: "regions-that-have-data-voice-packages",
    packagesOfCountry: "get-packages-of-country",
    getDataVoicePackagesOfCountry: "get-data-voice-packages-of-country",
    metaDataOfCountry: "meta-data-of-country",
    packagesOfRegion: "packages-of-region",
    dataVoicePackagesOfRegion: "data-voice-packages-of-region",
    metaDataOfRegion: "meta-data-of-region",
    globalPackages: "global-packages",
    dataVoiceGlobalPackages: "data-voice-global-packages",
    metaDataOfGlobal: "meta-data-of-global",
    packageCoverage: "package-coverage",
    packageDetail: "package-detail",
  },

  support: {
    contactUs: "contact-us",
    appSettings: "app-settings",
    helpCenterCategories: "help-center-categories",
    helpCenterDetail: "help-center-detail",
    slugs: "help-center-slugs",
  },
};
